import {
  Linkedin, Twitter, Youtube, Github, Instagram, Facebook, Mail, Globe,
  Link as LinkIcon, Rss, BookOpen, Send, Podcast, Music, Video, Image as ImageIcon,
  Briefcase, ExternalLink, Cloud
} from "lucide-react";

// Bluesky's butterfly logo — Lucide doesn't ship one, so we inline a tiny SVG
// component that matches the lucide-react API (accepts size + className).
const BlueskyIcon = ({ size = 16, className = "" }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 600 530"
       fill="currentColor" className={className} aria-hidden="true">
    <path d="M135.7 44.4C202.1 94.2 273.4 195.3 300 250c26.6-54.7 97.9-155.8 164.3-205.6 47.8-35.9 125.3-63.6 125.3 24.7 0 17.6-10.1 148-16 169.2-20.7 73.6-95.9 92.4-162.7 81 117.1 19.9 146.9 86.1 82.6 152.2-121.9 125.7-175.2-31.5-188.9-71.9-1.8-5.6-2.8-7.7-2.6-11 .2 3.3-.8 5.4-2.6 11-13.7 40.4-67 197.6-188.9 71.9-64.3-66.1-34.5-132.3 82.6-152.2-66.8 11.4-142-7.4-162.7-81C24.5 217 14.4 86.6 14.4 69 14.4-19.3 91.9 8.5 135.7 44.4z"/>
  </svg>
);

// Substack uses a stack-of-bars motif — also not in Lucide. Provide an inline icon
// so visitors and crawlers see a recognisable mark next to the Substack link.
const SubstackIcon = ({ size = 16, className = "" }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24"
       fill="currentColor" className={className} aria-hidden="true">
    <path d="M22.539 8.242H1.46V5.406h21.08v2.836zM1.46 10.812V24L12 18.11 22.54 24V10.812H1.46zM22.54 0H1.46v2.836h21.08V0z"/>
  </svg>
);

const ICON_MAP = {
  linkedin: Linkedin, twitter: Twitter, x: Twitter, youtube: Youtube,
  github: Github, instagram: Instagram, facebook: Facebook, mail: Mail,
  email: Mail, globe: Globe, link: LinkIcon, rss: Rss,
  substack: SubstackIcon,
  bluesky: BlueskyIcon, bsky: BlueskyIcon, butterfly: BlueskyIcon,
  cloud: Cloud,
  bookopen: BookOpen, book: BookOpen, send: Send, telegram: Send,
  podcast: Podcast, music: Music, spotify: Music, video: Video,
  image: ImageIcon, briefcase: Briefcase, externallink: ExternalLink,
};

export const getSocialIcon = (name) => ICON_MAP[(name || "").toLowerCase().replace(/[^a-z]/g, "")] || ExternalLink;

const SocialLinksRow = ({ links = [], legacyLinkedin = "", className = "", iconSize = 16, color = "text-[#1C2B3A]", hoverColor = "hover:text-[#B8945A]", testid = "social-links" }) => {
  const all = [...(links || [])];
  if (legacyLinkedin && !all.find((l) => (l.url || "").includes("linkedin.com"))) {
    all.unshift({ label: "LinkedIn", icon: "linkedin", url: legacyLinkedin });
  }
  if (all.length === 0) return null;
  return (
    <div className={`flex flex-wrap items-center gap-3 ${className}`} data-testid={testid}>
      {all.map((l, i) => {
        if (!l.url) return null;
        const Icon = getSocialIcon(l.icon);
        return (
          <a key={`${l.url}-${i}`} href={l.url} target="_blank" rel="noopener noreferrer"
             className={`inline-flex items-center gap-1.5 text-sm font-sans ${color} ${hoverColor} transition-colors`}
             title={l.label || l.url} data-testid={`${testid}-${(l.label || "link").toLowerCase().replace(/\s/g, "-")}-${i}`}>
            <Icon size={iconSize} /> <span>{l.label || "Link"}</span>
          </a>
        );
      })}
    </div>
  );
};

export default SocialLinksRow;
